import {
  FORGOT_PASSWORD_OK,
  FORGOT_PASSWORD_ERR,
} from "./forgot-password.action";

const InitState = {
  error: null,
  content: null,
};

export default function ForgotPasswordReducer(state = InitState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case FORGOT_PASSWORD_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
